import styled from "styled-components"

import {
  Wrapper as SupportersWrapper,
  ContentWrapper as SupportersContentWrapper,
  LogosWrapper as SupportersLogoWrapper,
} from "src/sections/mission/supporters/style"

export const Wrapper = styled(SupportersWrapper)``

export const ContentWrapper = styled(SupportersContentWrapper)``

export const LogosWrapper = styled(SupportersLogoWrapper)`
  img {
    max-width: 15rem;
    max-height: 5rem;
  }
`
